import { formatNumber } from "../data/essential";
import { Link } from "react-router-dom";
export const accountColumns = () => {
  const columns = [
    {
      name: "Id",
      cell: (row) => <div style={{ cursor: "pointer" }}>{row["id"]}</div>,
      sortable: true,
      sortFunction: (a, b) => b.id - a.id,
    },
    {
      name: "Type",
      cell: (row) => row["type"],
      sortable: true,
      sortFunction: (a, b) => a.type.localeCompare(b.type),
    },
    {
      name: "Names",
      cell: (row) => row["accountName"],
      sortable: true,
      sortFunction: (a, b) => a.accountName.localeCompare(b.accountName),
    },
    {
      name: (
        <div>
          Account
          <br /> number
        </div>
      ),
      cell: (row) => row["accountNumber"],
      sortable: true,
      sortFunction: (a, b) => b.accountNumber - a.accountNumber,
    },
    {
      name: "Monthly Fee",
      cell: (row) => `${formatNumber(row["monthlyFee"])} RWF`,
      sortable: true,
      sortFunction: (a, b) => b.monthlyFee - a.monthlyFee,
    },
    {
      name: "Outstanding",
      cell: (row) => `${formatNumber(row["outstandingAmount"])} RWF`,
      sortable: true,
      sortFunction: (a, b) => b.outstandingAmount - a.outstandingAmount,
    },
    {
      name: "Status",
      cell: (row) => row["status"],
      sortable: true,
      sortFunction: (a, b) => a.status.localeCompare(b.status),
    },
    {
      name: "Created On",
      cell: (row) => row["createdAt"],
      sortable: true,
      sortFunction: (a, b) => a.createdAt.localeCompare(b.createdAt),
    },
    {
      name: <div className='d-flex justify-content-end'>Actions</div>,
      cell: (row) => (
        <div>
          <Link to={`/loggedin/account/${row?.id}`}>
            <i
              className='fa fa-eye'
              style={{ color: "#124db1", cursor: "pointer" }}
              title='View account details'
            />
          </Link>
        </div>
      ),
    },
  ];
  return columns;
};
